<template>
  <div>
    <h3 class="diet-title">{{ title }}</h3>
    <el-checkbox-group v-model="checkList" :min="1" @change="updateDiet">
      <ul>
        <li v-for="diet in dietList" :key="diet.name" class="diet-element">
          <el-checkbox
            v-if="diet.name != 'Extras'"
            :label="diet.name"
            :disabled="disabled"
            :accesskey="diet.accessKey"
          >
            <p class="diet-title">
              {{ diet.label }}
              <svg-icon :icon="diet.icon" class="svg-diet-icon" />
            </p>
            <p v-if="displayDescription" class="diet-description">
              {{ diet.description }}
            </p>
          </el-checkbox>
        </li>
      </ul>
    </el-checkbox-group>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import difference from 'lodash.difference';
import get from 'lodash.get';
import SvgIcon from '@/components/SvgIcon';
import { NAVIGATION_ACCESS_KEYS } from '@/constants';

const { dietaryOptionsFilter: accessKeys } = NAVIGATION_ACCESS_KEYS;

export default {
  name: 'CheckboxGroup',
  components: {
    SvgIcon,
  },
  props: {
    displayDescription: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      checkList: [],
    };
  },
  created() {
    this.checkList = this.user.dietsInfo;
    this.$emit('checked', this.checkList);
  },
  computed: {
    ...mapGetters('user', { user: 'getUser' }),
    ...mapState('weeklyMenu', {
      weekDisabled: (state) => state.disabledWeekFlag,
      isDueDate: (state) => state.isDueDate,
    }),
    ...mapState('diets', { diets: (state) => state.diets }),
    ...mapState('user', {
      userOffice: (state) => state.user.officeInfo,
    }),
    dietList() {
      if (this.diets.length) {
        const country = get(this.userOffice, 'country', '');
        return this.diets
          .filter(
            (diet) => (diet.name !== 'Restaurant' && country === 'Mexico') || country !== 'Mexico'
          )
          .map((diet) => ({
            ...diet,
            icon: diet.name.toLowerCase(),
            label: this.$t(`settings.checkboxes.${diet.name.toLowerCase()}Label`),
            description: this.$t(`settings.checkboxes.${diet.name.toLowerCase()}Description`),
            accessKey: accessKeys[diet.name.toLowerCase()],
          }));
      }
      return [];
    },
  },
  methods: {
    ...mapActions('user', { addUsersDiet: 'addUsersDiet', deleteUsersDiet: 'deleteUsersDiet' }),
    async updateDiet(updatedValue) {
      this.$emit('checked', [...new Set([...updatedValue, 'Extras'])]);
      let dietsDifference = difference(updatedValue, this.user.dietsInfo);
      if (dietsDifference.length > 0) {
        const idToAdd = this.getIdFromDifference(dietsDifference[0]);
        this.addUsersDiet({
          id: idToAdd,
          name: dietsDifference[0],
        });
      } else {
        dietsDifference = difference(this.user.dietsInfo, updatedValue);
        const idToDelete = this.getIdFromDifference(dietsDifference[0]);
        if (idToDelete) {
          this.deleteUsersDiet({
            id: idToDelete,
            name: dietsDifference[0],
          });
        }
      }
    },
    getIdFromDifference(differenceValue) {
      const dietFromDifference = this.diets.filter((diet) => diet.name === differenceValue);
      if (dietFromDifference.length > 0) {
        return dietFromDifference[0].id;
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';

h3.diet-title {
  font-weight: bold;
  font-size: $card-title;
  margin-bottom: 20px;
  text-align: center;
}

.diet-element:not(:last-child) {
  margin-bottom: 14px;
}
.diet-description {
  font-size: $label-description-text-size;
  color: $label-description-text-color;
}

/deep/ .el-checkbox {
  &__label {
    display: inline-grid;
  }
  &__input {
    &.is-checked + {
      .el-checkbox {
        &__label {
          color: $label-text-color;
        }
      }
    }
    &.is-checked {
      .el-checkbox {
        &__inner {
          background-color: $checkbox-background-color;
          border-color: $checkbox-background-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CheckboxGroup.vue